import React, {useEffect, useState} from 'react';
import Prismic from '@prismicio/client';
import { RichText } from 'prismic-reactjs';
import './Research.css';

const Research = ({client}) => {
    const [summary, setSummary] = useState(null);
    const [doc, setDoc] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const response = await client.query(
                Prismic.Predicates.at('document.type', 'research_summary')
            )
            if (response) {
                setSummary(response.results[0]);
            }
            }
            fetchData()
    }, [client]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await client.query(
                Prismic.Predicates.at('document.type', 'research_grant'), {orderings : '[my.research_grant.position]'}
            )
            if (response) {
                setDoc(response.results);
            }
            }
            fetchData()
    }, [client]);
    

    if(doc.length > 1 && summary){
        return (
            <div className="Research">
                <h2>Research Summary</h2>
                <div>
                    <RichText render={summary.data.content}/>
                </div>
                <h2 className="borderless">Research Grants</h2>
                <h3 className="centered">{summary.data.grants_subtitle}</h3>
                <div>
                    <RichText render={summary.data.list}/>
                </div>
            </div>
        )
    } else {
        return <div className="Research">Loading...</div>
    }
};

export default Research;